import { z } from "zod/v4";

import { AssetSchema } from "../../../schemas/organization";

export const GetAssetRequestPathParamSchema = z.object({
  themeId: z.string(),
});

export type GetAssetRequestPathParamType = z.infer<
  typeof GetAssetRequestPathParamSchema
>;

export const GetAssetRequestQueryParamSchema = z.object({
  key: z.string(),
});

export type GetAssetRequestQueryParamType = z.infer<
  typeof GetAssetRequestQueryParamSchema
>;

export const GetAssetResponseBodySchema = z.object({
  asset: AssetSchema,
});

export type GetAssetResponseBodyType = z.infer<
  typeof GetAssetResponseBodySchema
>;
